import { Button, IconSet } from '@postscript/components';
import { RcsMessageButtonTypes } from 'constants/rcs';
import styled from 'styled-components';
import { RcsMessageButton } from 'types/rcs';
import { isRcsMessageOpenLinkButton } from 'types/rcs/typeGuards';

const StyledSuggestedActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-1);
  justify-content: flex-end;
  margin-top: var(--spacing-2);
`;

interface StyledSuggestedActionButtonProps {
  clickable: boolean;
}

const StyledSuggestedActionButton = styled(
  Button,
)<StyledSuggestedActionButtonProps>`
  align-items: center;
  border: 1px solid var(--border-color-dim);
  display: block;
  padding: calc(var(--spacing-1) / 3) var(--spacing-2)
    calc(var(--spacing-1) / 3) var(--spacing-1);
  pointer-events: ${({ clickable }) => (clickable ? 'auto' : 'none')};

  span {
    font-weight: normal;
  }
`;

interface SuggestedActionsPreviewProps {
  suggestedActions: RcsMessageButton[];
}

const SuggestedActionsPreview = ({
  suggestedActions,
}: SuggestedActionsPreviewProps) => {
  if (!suggestedActions.length) return null;

  return (
    <StyledSuggestedActions>
      {suggestedActions.map((action, index) => (
        <StyledSuggestedActionButton
          clickable={isRcsMessageOpenLinkButton(action)}
          icon={
            action.type === RcsMessageButtonTypes.CLICK_TO_REPLY
              ? IconSet.Message
              : IconSet.Link
          }
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          onClick={(e) => {
            e.stopPropagation();
            if (isRcsMessageOpenLinkButton(action))
              window.open(action.body.url, '_blank');
          }}
          size="small"
          variant="plain"
        >
          {action.body.text}
        </StyledSuggestedActionButton>
      ))}
    </StyledSuggestedActions>
  );
};

export default SuggestedActionsPreview;
